module.exports = __webpack_public_path__ + "static/img/200308.ea68ec6d.png";